// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__29fP3","overflowing":"ReadFullNote_overflowing__NPL5l"};